export const BOOK_SALES_DEMO_SOURCES = {
  contactSalesHeader: 'contact_sales_header',
  paywallEnterpriseDemo: 'paywall_enterprise_demo',
  pricingBusinessCard: 'pricing_business_card',
  pricingComparisonBusiness: 'pricing_comparison_business',
  pricingComparisonEnterprise: 'pricing_comparison_enterprise',
  pricingEnterpriseCard: 'pricing_enterprise_card',
  trialPaywallEnterprise: 'trial_paywall_enterprise',
  trialPricingEnterpriseBanner: 'trial_pricing_enterprise_banner',
  upgradePlanModalContactUs: 'upgrade_plan_modal_contact_us',
} as const;

export type BookSalesDemoSource = (typeof BOOK_SALES_DEMO_SOURCES)[keyof typeof BOOK_SALES_DEMO_SOURCES];
